import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'x-healthcheck',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './healthcheck.component.html',
})
export class HealthcheckComponent {}
